import { create } from 'zustand'

interface ApplicationsUIState {
  page: number
  perPage: number
  setPage: (page: number) => void
  setPerPage: (perPage: number) => void
  reset: () => void
}

export const useApplicationsStore = create<ApplicationsUIState>((set) => ({
  page: 1,
  perPage: 25,
  setPage: (page) => set({ page }),
  setPerPage: (perPage) => set({ perPage }),
  reset: () => set({ page: 1, perPage: 25 }),
}))
